// External libraries
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

// Internal modules
// @ts-expect-error TODO:'@/styles
import { FLAGS_SPRITE_URL } from '@/styles';

// CSS styles
const dropdownLabelStyleOverrides = css`
  opacity: 0;
`;

const getDropdownContainerStyleOverrides = (
  flagPos: number,
): SerializedStyles => css`
  position: absolute;
  background-image: url(${FLAGS_SPRITE_URL});
  background-position: 8px ${flagPos}px;
  background-repeat: no-repeat;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 50px;

  /* Down caret */
  &::before {
    right: 10px;
  }
  @media (max-width: 390px) {
    background-position: 18px ${flagPos}px;
  }
`;

export { dropdownLabelStyleOverrides, getDropdownContainerStyleOverrides };
